import { BoxProps, TextProps } from '@jfs/ui-new/'
import { Colors } from '../../util/util'

const centerAlignWithMinWidth = {
  justifyContent: 'center',
  marginLeft: 'auto',
  marginRight: 'auto',
  alignItems: 'center',
} as BoxProps

const successCommonObj = {
  backgroundColor: Colors.GREEN_BG_C,
  color: Colors.GREEN_C,
  ...centerAlignWithMinWidth,
  flex: 1,
  borderRadius: 2,
  maxWidth: 70,
} as BoxProps

const failureCommonObj = {
  backgroundColor: Colors.RED_BG_C,
  color: Colors.RED_C,
  ...centerAlignWithMinWidth,
  flex: 1,
  borderRadius: 2,
  maxWidth: 60,
} as BoxProps

const pendingCommonObj = {
  backgroundColor: Colors.ORANGE_BG_C,
  color: Colors.ORANGE_C,
  ...centerAlignWithMinWidth,
  flex: 1,
  borderRadius: 2,
  maxWidth: 60,
} as BoxProps

export const styles = {
  header: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    textAlign: 'left',
    backgroundColor: 'BACKGROUND',
    borderBottomWidth: 1,
    borderBottomColor: 'GREY_SEPARATOR',
  } as BoxProps,
  item: {
    flexDirection: 'row',
    textAlign: 'left',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: 'GREY_SEPARATOR',
    flexShrink: 1,
  } as BoxProps,
  extendedWidth: {
    maxWidth: 190,
    minWidth: 170,
    wordBreak: 'break-all',
  } as BoxProps,
  extendedExtraWidth: {
    maxWidth: 296,
    minWidth: 296,
    wordBreak: 'keep-all',
  } as BoxProps,
  longGrid: {
    minWidth: 398,
  } as BoxProps,
  smallColumnWidth: {
    maxWidth: 72,
    minWidth: 68,
    wordBreak: 'break-all',
  } as BoxProps,
  containerBox: {
    flexDirection: 'row',
    alignContent: 'space-between',
    width: '100%',
  } as BoxProps,
  gridStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'space-between',
    flex: 1,
  } as BoxProps,
  titleheaderView: {
    padding: 16,
    paddingHorizontal: 10,
    flexDirection: 'row',
    minWidth: 120,
    justifyContent: 'center',
    alignSelf: 'stretch',
    opacity: 0.9,
    backgroundColor: 'BACKGROUND',
    height: 60,
    alignContent: 'space-between',
    flex: 1,
  } as BoxProps,
  titleHeader: {
    color: 'BLACK_21',
    fontSize: 12,
    textAlign: 'center',
    textTransform: 'capitalize',
    fontFamily: 'jioType-bold',
  } as TextProps,
  titleView: {
    opacity: 0.88,
    paddingVertical: 16,
    paddingHorizontal: 16,
    flexDirection: 'row',
    minWidth: 120,
    alignSelf: 'stretch',
    flex: 1,
  } as BoxProps,
  ovalShapeView: {
    width: 48,
    height: 30,
    padding: 8,
    backgroundColor: 'ERROR',
    borderRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  bubbleTextProps: {
    fontSize: 12,
    fontWeight: '600',
    color: 'WHITE',
  } as TextProps,
  linkStyle: {
    color: 'BLUE',
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'jiotype-medium',
  } as TextProps,
  ernTitle: {
    fontSize: 12,
    fontWeight: '600',
    marginRight: 4,
    flexShrink: 1,
    color: 'BLUE',
  } as TextProps,
  title: {
    fontSize: 12,
    textAlign: 'center',
    color: 'BLACK_21',
    flexShrink: 1,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  loading: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingRight: 26,
    maxWidth: undefined,
    height: 48,
    alignContent: 'center',
  } as BoxProps,
  copyStyle: {
    backgroundColor: 'BLACK_LIGHT',
    color: 'BLACK',
    align: 'center',
    flex: 1,
    justifyContent: 'center',
    borderRadius: 2,
    minWidth: 36,
  } as BoxProps,
  copyTxtStyle: {
    color: 'LIGHT_BLACK',
    fontSize: 12,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  copiedStyle: {
    backgroundColor: 'GREEN',
    color: 'GREEN',
    align: 'center',
    flex: 1,
    justifyContent: 'center',
    borderRadius: 2,
    minWidth: 36,
  } as BoxProps,
  copiedTxtStyle: {
    color: 'WHITE',
    fontSize: 12,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  // TODO: add correct status text and bg color
  Complete: {
    backgroundColor: Colors.GREEN_BG_C,
    color: Colors.GREEN_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 70,
  } as BoxProps,
  Processed: {
    backgroundColor: Colors.GREEN_BG_C,
    color: Colors.GREEN_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 65,
  } as BoxProps,
  SUCCESS: {
    ...successCommonObj,
  } as BoxProps,
  PAID: {
    backgroundColor: Colors.GREEN_BG_C,
    color: Colors.GREEN_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  ACTIVE: {
    backgroundColor: Colors.GREEN_BG_C,
    color: Colors.GREEN_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  Blocked: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    pv: 3,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  Deleted: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    pv: 3,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  INITIATED: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  Failure: {
    ...failureCommonObj,
  },
  EXPIRED: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  Completed: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  COMPLETED: {
    backgroundColor: Colors.GREY_EB,
    color: Colors.GREY_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  CANCELED: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  FAILURE: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 70,
  } as BoxProps,
  FAILED: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 70,
  } as BoxProps,
  Awaited: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 60,
  } as BoxProps,
  CANCELLED: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  AWAITED: {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 70,
  } as BoxProps,
  Active: {
    backgroundColor: Colors.GREEN_BG_C,
    color: Colors.GREEN_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    pv: 3,
    alignSelf: 'center',
    borderRadius: 2,
    paddingVertical: 4,

    maxWidth: 80,
  } as BoxProps,
  Inactive: {
    backgroundColor: Colors.GREY_EB,
    color: Colors.GREY_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    paddingVertical: 4,
    maxWidth: 70,
  } as BoxProps,
  INACTIVE: {
    backgroundColor: Colors.GREY_EB,
    color: Colors.GREY_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  Pending: {
    ...pendingCommonObj,
  } as BoxProps,
  PENDING: {
    ...pendingCommonObj,
  } as BoxProps,
  Bounced: {
    backgroundColor: 'BLACK_75',
    color: Colors.BLACK_1A,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 60,
  } as BoxProps,
  BOUNCED: {
    backgroundColor: 'BLACK_75',
    color: Colors.BLACK_1A,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 70,
  } as BoxProps,
  Processing: {
    backgroundColor: Colors.LIGHT_BLUE,
    color: 'BLUE',
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  ISSUED: {
    backgroundColor: Colors.LIGHT_BLUE,
    color: 'BLUE',
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  INPROCESS: {
    backgroundColor: Colors.LIGHT_BLUE,
    color: 'BLUE',
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  IN_PROCESS: {
    backgroundColor: Colors.LIGHT_BLUE,
    color: 'BLUE',
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  SCHEDULED: {
    backgroundColor: Colors.WASHED_YELLOW_LIGHT,
    color: Colors.MUD_YELLOW_DARK,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  PAUSED: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 70,
  } as BoxProps,
  'In Progress': {
    backgroundColor: Colors.ORANGE_BG_C,
    color: Colors.ORANGE_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
  Failed: {
    backgroundColor: Colors.RED_BG_C,
    color: Colors.RED_C,
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 70,
  } as BoxProps,
  ACCEPTED: {
    backgroundColor: Colors.LIGHT_BLUE,
    color: 'BLUE',
    ...centerAlignWithMinWidth,
    flex: 1,
    borderRadius: 2,
    maxWidth: 80,
  } as BoxProps,
}
